import { createReducer } from '@reduxjs/toolkit'
import { cartActions } from './actions'
import { initialState } from './initialState'

/**
 * Função auxiliar para gerar ID do item do carrinho
 */
const generateCartItemId = (productId: string) => {
  return productId
}

/**
 * Reducer do módulo Cart
 */
export const cartReducer = createReducer(initialState, (builder) => {
  builder
    // Add item
    .addCase(cartActions.addItem, (state, action) => {
      const { product, quantity = 1, willReturnScrap } = action.payload
      if (willReturnScrap !== undefined) {
        state.scrapPreference = willReturnScrap
      }
      const itemId = generateCartItemId(product.id)

      const existingItemIndex = state.items.findIndex(
        item => generateCartItemId(item.product.id) === itemId
      )

      if (existingItemIndex >= 0) {
        state.items[existingItemIndex].quantity += quantity
        if (willReturnScrap !== undefined) {
          state.items[existingItemIndex].willReturnScrap = willReturnScrap
        }
      } else {
        state.items.push({
          product,
          quantity,
          ...(willReturnScrap !== undefined && { willReturnScrap })
        })
      }
    })
    .addCase(cartActions.updateItemScrapPreference, (state, action) => {
      const { productId, willReturnScrap } = action.payload
      const item = state.items.find(i => generateCartItemId(i.product.id) === productId)
      if (item) item.willReturnScrap = willReturnScrap
    })
    
    // Remove item
    .addCase(cartActions.removeItem, (state, action) => {
      const itemId = action.payload
      state.items = state.items.filter(item =>
        generateCartItemId(item.product.id) !== itemId
      )
    })
    
    // Update quantity
    .addCase(cartActions.updateQuantity, (state, action) => {
      const { id, quantity } = action.payload
      const itemIndex = state.items.findIndex(item =>
        generateCartItemId(item.product.id) === id
      )
      
      if (itemIndex >= 0) {
        if (quantity <= 0) {
          state.items.splice(itemIndex, 1)
        } else {
          state.items[itemIndex].quantity = quantity
        }
      }
    })
    
    // Clear cart
    .addCase(cartActions.clearCart, (state) => {
      state.items = []
      state.isOpen = false
    })
    // Preferência de sucata
    .addCase(cartActions.setScrapPreference, (state, action) => {
      state.scrapPreference = action.payload
    })
    
    // Toggle cart
    .addCase(cartActions.toggleCart, (state) => {
      state.isOpen = !state.isOpen
    })
    
    // Open cart
    .addCase(cartActions.openCart, (state) => {
      state.isOpen = true
    })
    
    // Close cart
    .addCase(cartActions.closeCart, (state) => {
      state.isOpen = false
    })
    
    // Load cart
    .addCase(cartActions.loadCart, (state, action) => {
      state.items = action.payload
    })
})

